export default __webpack_public_path__ + "static/media/watch-free-videos.d63de102.png";